import React from 'react'
import Header from './Header'
import Bottom from './Bottom'
import './contact.css'

function Contact() {

  const handlesubmit=()=>{
    
  }

  return (
    <div className='contact'>
      <Header/>
      <div className='contacthd'>
        <h1>Contact us</h1>
        <div className='abtshd'></div>
      </div>

      <div className='contact_body'>

        <div className='comp'>
          <h1>Head Office</h1>

          <h3>Location</h3>
          <p>
              HQ OFFICE: 163-10 Sareung-ro, Jingeon-eup, Namyangju-si, Gyeonggi-do, South Korea
          </p>

          <h3>Contact info</h3>
          <p>  support@GlobalExpresscompany.org</p>
          <p>  +12146398281</p>
          <p></p>
        </div>


        <input placeholder='Full name'/>
        <input placeholder='Email Address'/>
        <input placeholder='Phone number'/>
        <textarea placeholder='write a message' />
        <button onClick={handlesubmit} >SUBMIT</button>
      </div>

      <Bottom/>
    </div>
  )
}

export default Contact